import { GrcNotify, NotifyType } from '@grc/ui-package';
import { orderService } from '@grc/ui-shared/lib/components/common/constants/constants';
import { fetchMyWorkItemsSummary } from '../../common/constants/url-constants';
import { IOperationalCardCounts } from '../../models/home/operational-card.interface';

const inflightSummary = new Map<string, Promise<IOperationalCardCounts[]>>();

export const GetMyWorkItemsSummary = async (
  fetchData: any,
  params: Record<string, unknown>
): Promise<IOperationalCardCounts[]> => {
  const key = JSON.stringify(params ?? {});
  const existing = inflightSummary.get(key);
  if (existing) return existing;

  const request = fetchData(
    fetchMyWorkItemsSummary,
    (message: string) => GrcNotify({ message, status: NotifyType.Error }),
    orderService,
    params
  )
    .then((response: any) => {
      const data = response?.data;
      return (Array.isArray(data) ? data : data?.items ?? []) as IOperationalCardCounts[];
    })
    .catch((error: any) => {
      GrcNotify({ message: error.message, status: NotifyType.Error });
      return [] as IOperationalCardCounts[];
    })
    .finally(() => {
      inflightSummary.delete(key);
    });

  inflightSummary.set(key, request);
  return request;
};

export default GetMyWorkItemsSummary;
